import { Link } from 'react-router-dom';
import { XCircle, ArrowRight, RefreshCw } from 'lucide-react';
import { SEOHead } from '@/components/SEOHead';

export function IntakeCancelled() {
  return (
    <div className="bg-zinc-950 min-h-screen flex items-center">
      <SEOHead 
        title="Payment Cancelled | OnPoint WFM Analytics Lab"
        description="Your payment was cancelled. You can return to the intake form to try again."
      />
      <div className="container-site py-32 max-w-2xl mx-auto text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-zinc-800 border border-zinc-700 mb-8">
          <XCircle size={24} className="text-zinc-400" />
        </div>
        <span className="text-xs font-mono tracking-widest uppercase text-zinc-500 block mb-5">
          Payment Cancelled
        </span>
        <h1 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-zinc-100 mb-6">
          Payment Not Completed
        </h1>
        <p className="text-base text-zinc-400 leading-relaxed mb-4">
          Your payment was cancelled or not completed. Your intake information has not been submitted.
        </p>
        <p className="text-sm text-zinc-500 leading-relaxed mb-10">
          If you encountered an issue or have questions about the payment process, please contact us.
          You can also return to the intake form to try again.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/intake"
            data-testid="cancelled-retry-link"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-amber-500 text-zinc-900 rounded-md text-sm font-medium hover:bg-amber-400 transition-colors duration-200"
          >
            Return to Intake <RefreshCw size={14} />
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-zinc-700 text-zinc-300 rounded-md text-sm hover:border-zinc-500 hover:text-white transition-colors duration-200"
          >
            Contact Us
          </Link>
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-zinc-700 text-zinc-300 rounded-md text-sm hover:border-zinc-500 hover:text-white transition-colors duration-200"
          >
            Return Home <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </div>
  );
}
